import axios from "axios";
import { del, get, post, patch,  put } from "./internships_api_helper";
import * as url from "./internships_url_helper";





// Get features
export const getInternships = () => get(url.GET_INTERNSHIPS);


// Add feature
//export const addNewFeature = feature => post(url.ADD_NEW_ACTION, feature);
//export const addNewBranch = branch => post(url.ADD_NEW_BRANCH, JSON.stringify(branch));

export const addNewInternship = internship => post(url.ADD_NEW_INTERNSHIP, internship);



// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateInternship = internship => patch(`${url.UPDATE_INTERNSHIP}/${internship.id}`,  internship);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteInternship = internship => del(`${url.DELETE_INTERNSHIP}/${internship.id}`);







export {
  //getLoggedInUser,
  
  
};
